export default __webpack_public_path__ + "static/media/android.9f0270e0.png";